import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-add-event-popup",
  templateUrl: "./add-event-popup.component.html",
  styleUrls: ["./add-event-popup.component.scss"],
})
export class AddEventPopupComponent implements OnInit {
  form: FormGroup;
  modalTitle: string;
  isAddMode: boolean;
  eventData: any;
  eventId: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.eventId = this.eventData?.id;
    this.modalTitle = this.eventId ? "Edit Event" : "Add Event";
    let initialEventDate;
    if (this.eventData?.attributes?.eventDate) {
      const localDate = new Date(this.eventData.attributes.eventDate);
      // Adjust for UTC+7
      const utcPlus7 = new Date(localDate.getTime() + 7 * 60 * 60 * 1000);
      initialEventDate = utcPlus7.toISOString().slice(0, 16); // Converts to local date string as UTC+7
    } else {
      const currentDate = new Date();
      const utcPlus7Current = new Date(
        currentDate.getTime() + 7 * 60 * 60 * 1000
      );
      initialEventDate = utcPlus7Current.toISOString().slice(0, 16); // Current local date and time as UTC+7
    }

    console.log(initialEventDate, "Initial Event Date"); // Check the processed date
    this.form = new FormGroup({
      title: new FormControl(
        this.eventData?.attributes?.title ?? "",
        Validators.required
      ),
      description: new FormControl(
        this.eventData?.attributes?.description ?? ""
      ),
      eventDate: new FormControl(initialEventDate, Validators.required),
    });
  }

  private toLocalISOString(date: Date): string {
    const tzOffset = -date.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localISOTime = new Date(date.getTime() + tzOffset)
      .toISOString()
      .slice(0, -1);
    // Return only the date and time parts
    return localISOTime.slice(0, 16);
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.closeModal(true);
    }
  }

  closeModal(update: boolean = false): void {
    if (!update) {
      this.activeModal.dismiss(false);
      return;
    }
    this.activeModal.dismiss({
      ...(this.eventId
        ? { id: this.eventId, ...this.form.value }
        : this.form.value),
      eventDate: new Date(this.form.value.eventDate).toISOString(),
    });
  }
}
